import eventMitt from '@jswork/event-mitt'

import { logInfo } from '@shared/helpers/Logger'

class Events {
  constructor() {
    if (Events._instance) {
      return Events._instance
    }
    Events._instance = this
  }

  emit(key, data) {
    logInfo(['%cEVENT.EMIT', 'color: yellow', key, data])
    eventMitt.default.emit(key, data)
  }

  off(key, callback) {
    eventMitt.default.off(key, callback)
  }

  on(key, callback) {
    eventMitt.default.on(key, callback)
  }

  one(key, callback) {
    eventMitt.default.one(key, callback)
  }

  once(key, callback) {
    eventMitt.default.once(key, callback)
  }
}

export default new Events()
